export const NotFound = () => {
	// DO DO - update after design
	return <h1>This is page not found</h1>;
};
